import { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import POSHeader from './kiosk/POSSection/POSHeader';
import MediaLibrary from './signage/MediaLibrary';
import AnnouncementManager from './signage/AnnouncementManager';
import PlaylistSettings from './signage/PlaylistSettings';
import StorageManager from './signage/StorageManager';
import PlaylistPreview from './signage/PlaylistPreview'; // ✅ NEW IMPORT

function Signage() {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('media');

  // Detect if we're in kiosk mode
  const isKioskMode = location.pathname.startsWith('/kiosk');

  // Handle logout for kiosk mode
  const handleLogout = () => {
    logout();
    navigate(isKioskMode ? '/kiosk/login' : '/login');
  };

  const tabs = [
    { id: 'media', label: 'Media Library' },
    { id: 'announcements', label: 'Announcements' },
    { id: 'playlist', label: 'Playlist Preview' }, // ✅ NEW TAB
    { id: 'settings', label: 'Settings' },
    { id: 'storage', label: 'Storage' },
  ];

  return (
    <div className="font-libre min-h-screen bg-gray-50">
      {/* Show POSHeader if in kiosk mode */}
      {isKioskMode && (
        <div className="px-6 pt-6">
          <POSHeader user={user} onLogout={handleLogout} />
        </div>
      )}

      <div className="p-6">
        {/* Header - Only show if NOT in kiosk mode (POSHeader handles kiosk) */}
        {!isKioskMode && (
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900 font-raleway">Signage Management</h1>
            <p className="text-sm text-gray-600 mt-2">
              Logged in as: <span className="font-semibold text-purple-600">{user.username}</span> 
              <span className="ml-2 px-2 py-1 bg-purple-100 text-purple-800 rounded text-xs font-medium uppercase">
                {user.role}
              </span>
            </p>
          </div>
        )}

        {/* Tabs */}
        <div className="border-b border-gray-300 mb-6">
          <div className="flex gap-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 font-medium text-sm rounded-t-lg transition-all duration-200 ${
                  activeTab === tab.id
                    ? 'bg-white text-purple-600 border-b-2 border-purple-600 shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-lg shadow-sm p-6 min-h-[600px]">
          {activeTab === 'media' && <MediaLibrary user={user} />}
          {activeTab === 'announcements' && <AnnouncementManager user={user} />}
          {activeTab === 'playlist' && <PlaylistPreview user={user} />} {/* ✅ NEW TAB CONTENT */}
          {activeTab === 'settings' && <PlaylistSettings user={user} />}
          {activeTab === 'storage' && <StorageManager user={user} />}
        </div>
      </div>
    </div>
  );
}

export default Signage;